module.exports = __webpack_public_path__ + "static/media/kodflix.07de8a20.png";